module.exports = __webpack_public_path__ + "static/media/logo-single-blue.269cd82c.png";